export { background, border, color, flexbox, grid, layout, position, shadow, space, typography } from '../styled-system';
//# sourceMappingURL=constants.js.map